<template>
  <div class="container pap-form">
    <div v-if="showForm" class="card">
      <!-- <h5 class="card-header bg-primary text-white">
        <i class="far fa-address-card mr-2"></i>User Profile / Preferences
      </h5> -->
      <FormTitle
        title="User Profile / Preferences"
        iconclass="far fa-address-card mr-2"
      />
      <div class="card-body">
        <b-form novalidate @submit.prevent="doEdit()">
          <!-- <b-form novalidate> -->
          <h5 class="pap-form__form-subhead">
            <ToggleControl toggleId="emnot">Email Notifications</ToggleControl>
          </h5>
          <b-collapse id="emnot">
            <p class="pap-form__text">
              Choose whether or not you wish to be emailed whenever one of your
              images is selected for a Pixapup book/calendar and when the
              book/calendar has been published. Note: The email address we use
              is your Pixapup login email address.
            </p>

            <b-form-checkbox
              id="checkbox-agreeEmailNotify"
              v-model="notifications.agreeEmailNotify.value"
              name="checkbox-agreeEmailNotify"
              :value="true"
              :unchecked-value="false"
              @change="fieldOnInput('agreeEmailNotify', 'notifications')"
              :disabled="notifications.agreeEmailNotify.disabled"
            >
              <p class="pap-form__text m-0">
                Yes, I wish to receive email notifications
              </p>
            </b-form-checkbox>

            <!-- <p class="text-primary text-smaller-2 m-3 text-center">
            Be sure to click the <strong>Save</strong> button at the bottom.
          </p> -->

            <!-- <SaveButton :showing="" :clicked="" /> -->
            <FormErrorAlert
              :showAlert="sections.notifications.alertNotice.show"
              :msg="sections.notifications.alertNotice.message"
            />

            <SaveButton
              form-section="notifications"
              :resets="sections.notifications.saveButton.resets"
              :done="sections.notifications.saveButton.doneSaving"
              @click="doEdit($event)"
              :disabled="sections.notifications.saveButton.disabled"
            />

            <!-- 
          <div class="text-center mt-2">
            <button
              v-if="!saveButton['notifications'].showing"
              class="btn btn-success btn-sm"
              disabled
            >
              <i class="fas fa-check mr-1" style="font-size: 0.8rem"></i>
              Saved
            </button>

            <b-overlay
              :show="saveButton['notifications'].clicked"
              rounded
              opacity="0.2"
              spinner-small
              spinner-variant="white"
              class="d-inline-block"
            >
              <button
                v-if="saveButton['notifications'].showing"
                @click="doEdit('notifications')"
                type="button"
                class="btn btn-sm btn-submit"
              >
                {{ saveButton['notifications'].text }}
              </button>
            </b-overlay>
          </div> -->

            <hr class="mb-4" color="#dddddd" />
          </b-collapse>

          <!-- <h5 class="pap-form__form-subhead">Layout Settings</h5> -->
          <h5 class="pap-form__form-subhead">
            <ToggleControl toggleId="layset">Layout Settings</ToggleControl>
          </h5>
          <b-collapse id="layset">
            <div>
              <b-form-checkbox
                id="checkbox-navBarSticky"
                v-model="layout.navBarSticky.value"
                name="checkbox-navBarSticky"
                :value="true"
                :unchecked-value="false"
                @change="fieldOnInput('navBarSticky', 'layout')"
                :disabled="layout.navBarSticky.disabled"
              >
                <p class="pap-form__text m-0">
                  Make the Main Menu Navigation Bar stay at the top of the page;
                  uncheck to have it scroll with the page.
                </p>
              </b-form-checkbox>

              <b-form-checkbox
                class="mt-3"
                id="checkbox-showWelcomeBar"
                v-model="layout.showWelcomeBar.value"
                name="checkbox-showWelcomeBar"
                :value="true"
                :unchecked-value="false"
                @change="fieldOnInput('showWelcomeBar', 'layout')"
                :disabled="layout.showWelcomeBar.disabled"
              >
                <p class="pap-form__text m-0">
                  Show the Welcome Bar (below the navigation bar); uncheck to
                  hide.
                </p>
              </b-form-checkbox>

              <FormErrorAlert
                :showAlert="sections.layout.alertNotice.show"
                :msg="sections.layout.alertNotice.message"
              />
              <SaveButton
                form-section="layout"
                :resets="sections.layout.saveButton.resets"
                :done="sections.layout.saveButton.doneSaving"
                @click="doEdit($event)"
                :disabled="sections.layout.saveButton.disabled"
              />

              <hr class="mb-4" color="#dddddd" />
            </div>
          </b-collapse>

          <!-- <h5 class="pap-form__form-subhead">
            Form Field Preferences: Upload New Image
          </h5> -->
          <h5 class="pap-form__form-subhead">
            <ToggleControl toggleId="uploadfill"
              >New Upload: One-Click Fill Form Settings</ToggleControl
            >
          </h5>
          <!-- <p class="text-primary text-smaller-1 mt-2 mb-4"> -->
          <b-collapse id="uploadfill">
            <p class="pap-form__text">
              Save time when creating a new upload. There's a One-Click Fill
              Form button on the Upload New Image form. Values you store here
              will be filled in when you click that Fill Form button.
            </p>
            <!-- <hr class="mb-4" color="#dddddd" /> -->
            <!-- -------------------------------- Dog name  -->
            <b-form-group
              id="dogName-group"
              label="Dog Name"
              label-for="dogName"
              label-class="label-bold"
            >
              <b-form-input
                id="dogName"
                :maxlength="fieldMaxLength('dogName')"
                placeholder="Dog Name"
                @input="fieldOnInput('dogName')"
                v-model="form.dogName.value"
                trim
                :disabled="form.dogName.disabled"
              ></b-form-input>
            </b-form-group>

            <!-- -------------------------------- Breed  -->
            <SelectBreed
              id="breed-id"
              label="Breed"
              :selected="form.breedId.value"
              @breed-selected="setBreed($event)"
              :disabled="form.breedId.disabled"
            />

            <!-- -------------------------------- Breed Desc   **CONDITIONAL if breedId is 'mixed' -->
            <b-form-group
              v-show="form.breedId.value === 'mixed'"
              id="breed-desc-group"
              label="Breed Description"
              label-for="breedDesc"
              label-class="label-bold"
            >
              <p class="form-text text-secondary px-3 pb-1 m-0">
                For <strong>Breed</strong> you selected 'Mixed' - Briefly
                describe your mixed breed
              </p>
              <b-form-input
                id="breed-desc"
                :maxlength="fieldMaxLength('breedDesc')"
                placeholder="Describe your mixed breed"
                @input="fieldOnInput('breedDesc')"
                v-model="form.breedDesc.value"
                trim
                :disabled="form.breedDesc.disabled"
              ></b-form-input>
            </b-form-group>

            <!-- -------------------------------- Country  -->
            <SelectCountry
              id="country"
              label="Country / Territory"
              :selected="form.country.value"
              @country-selected="setField($event, 'country')"
              :disabled="form.country.disabled"
            />

            <!-- -------------------------------- State **CONDITIONAL if country is US -->
            <SelectState
              v-if="form.country.value === 'US'"
              id="state"
              label="State"
              :selected="form.state.value"
              @state-selected="setField($event, 'state')"
              :disabled="form.state.disabled"
            />

            <!-- ------------------------ Province  **CONDITIONAL if country is *not* US -->
            <ProvinceField
              v-show="
                form.country.value !== 'US' &&
                form.country.value !== '' &&
                form.country.value !== '-'
              "
              id="province"
              :maxlength="fieldMaxLength('province')"
              label="Province / Region"
              placeholder="Province / Region"
              :key="componentKey"
              :init="form.province.value"
              @province-value-input="setField($event, 'province')"
              :disabled="form.province.disabled"
            />

            <!-- -------------------------------- City -->
            <b-form-group
              id="city-group"
              label="City"
              label-for="city"
              label-class="label-bold"
            >
              <b-form-input
                id="city"
                :maxlength="fieldMaxLength('city')"
                placeholder="City"
                @input="fieldOnInput('city')"
                v-model="form.city.value"
                trim
                :disabled="form.city.disabled"
              ></b-form-input>
            </b-form-group>

            <!-- -------------------------------- First name  -->
            <b-form-group
              id="fName-group"
              label="Your First Name"
              label-for="fName"
              label-class="label-bold"
            >
              <b-form-input
                id="fName"
                :maxlength="fieldMaxLength('fName')"
                placeholder="First Name"
                @input="fieldOnInput('fName')"
                v-model="form.fName.value"
                trim
                :disabled="form.fName.disabled"
              ></b-form-input>
            </b-form-group>

            <!-- -------------------------------- Last name  -->

            <b-form-group
              id="lName-group"
              label="Your Last Name"
              label-for="lName"
              label-class="label-bold"
            >
              <b-form-input
                id="lName"
                :maxlength="fieldMaxLength('lName')"
                placeholder="Last Name"
                @input="fieldOnInput('lName')"
                v-model="form.lName.value"
                trim
                :disabled="form.lName.disabled"
              ></b-form-input>
            </b-form-group>

            <!-- -------------------------------- Caption  -->
            <b-form-group
              id="caption"
              label="Image Caption"
              label-class="label-bold"
            >
              <!-- <p class="form-text text-dark text-smaller-1 px-2"> -->
              <p class="pap-form__text pap-form__text--field-desc">
                When published in a book or calendar, your dog image will have a
                text caption at the bottom of the image that includes your first
                name and either your FULL last name OR just the first INITIAL of
                your last name.
              </p>
              <!-- <p class="form-text text-dark text-smaller-1 px-2"> -->
              <p class="pap-form__text pap-form__text--field-desc">
                Indicate your preference: CHECK the box to have the caption use
                your FULL last name. UNCHECK the box to user first INITIAL only.
              </p>
              <div class="form-text text-center">
                <b-form-checkbox
                  id="checkbox-use-full-lname"
                  v-model="form.captionLastName.value"
                  name="checkbox-caption-last-name"
                  value="full"
                  unchecked-value="initial"
                  :disabled="form.captionLastName.disabled"
                >
                  Use my FULL last name in the caption
                </b-form-checkbox>
              </div>
            </b-form-group>

            <FormErrorAlert
              :showAlert="sections.form.alertNotice.show"
              :msg="sections.form.alertNotice.message"
            />
            <SaveButton
              form-section="form"
              :resets="sections.form.saveButton.resets"
              :done="sections.form.saveButton.doneSaving"
              @click="doEdit($event)"
              :disabled="sections.form.saveButton.disabled"
            />
          </b-collapse>
          <!-- <button
            @click="setSubmitted"
            type="submit"
            class="btn btn-block btn-submit pap-form__btn"
          >
            Save
          </button> -->
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleControl from '@/components/layout/ToggleControl';
import FormTitle from '@/components/form/FormTitle';
import SelectBreed from '@/components/form/FormSelectListBreeds';
import SelectCountry from '@/components/form/FormSelectListCountries';
import SelectState from '@/components/form/FormSelectListStates';
import ProvinceField from '@/components/form/FormProvinceField';

import SaveButton from '@/components/form/FormSaveButton';
import FormErrorAlert from '@/components/form/FormErrorAlert';

import { UploadPreferences } from '@/models/PreferencesUpload';
import { NotificationPreferences } from '@/models/PreferencesNotification';
import { LayoutPreferences } from '@/models/PreferencesLayout';

import { mapGetters } from 'vuex';

export default {
  name: 'PageUserProfile',
  components: {
    ToggleControl,
    FormTitle,
    SelectBreed,
    SelectCountry,
    SelectState,
    ProvinceField,
    SaveButton,
    FormErrorAlert,
  },
  data: function () {
    return {
      // showSaveButton: true,
      showEditResult: false,
      resultType: '',
      resultSuccessMsg: 'Your User Profile settings were saved.',
      resultErrorMsg: '',

      // Form sections, by name. Track/handle 'Save' button and alert notice states
      sections: {
        notifications: {
          model: NotificationPreferences,
          saveButton: {
            doneSaving: false,
            resets: 0,
            disabled: false,
          },
          alertNotice: {
            show: false,
            message: '', // maybe have this??
          },
        },
        layout: {
          model: LayoutPreferences,
          postUpdate: this.updateLayoutState, // function to run 'post update', i.e. after successful update/save op
          saveButton: {
            doneSaving: false,
            resets: 0,
            disabled: false,
          },
          alertNotice: {
            show: false,
            // text: '' // maybe have this??
          },
        },
        form: {
          model: UploadPreferences,
          saveButton: {
            doneSaving: false,
            resets: 0,
            disabled: false,
          },
          alertNotice: {
            show: false,
            // text: '' // maybe have this??
          },
        },
      },

      // Notifications settings -----------------------------
      notifications: {
        agreeEmailNotify: {
          value: null,
          disabled: false,
        },
      },

      // App layout settings -----------------------------
      layout: {
        navBarSticky: {
          value: true,
          disabled: false,
        },
        showWelcomeBar: {
          value: true,
          disabled: false,
        },
      },

      // New image upload text default settings -----------------------------
      form: {
        // agreeEmailNotify: {
        //   value: null,
        // },
        dogName: {
          value: '',
          disabled: false,
        },
        breedId: {
          value: '',
          disabled: false,
        },
        breedDesc: {
          value: '',
          disabled: false,
        },
        country: {
          value: '',
          disabled: false,
        },
        state: {
          value: '',
          disabled: false,
        },
        province: {
          value: '',
          disabled: false,
        },
        city: {
          value: '',
          disabled: false,
        },
        fName: {
          value: '',
          disabled: false,
        },
        lName: {
          value: '',
          disabled: false,
        },
        captionLastName: {
          value: 'full',
          disabled: false,
        },
      },

      formSubmitted: false,

      formSectionSubmitted: '',

      componentKey: '',
    };
  },

  computed: {
    ...mapGetters('auth', ['authUser']),
    ...mapGetters('layout', ['navBarSticky', 'showWelcomeBar']),
    ...mapGetters(['userProfile']),
    showForm: function () {
      return !this.showEditResult;
    },
    resultHeader: function () {
      if (this.resultType === 'success') {
        return 'Success!';
      }
      if (this.resultType === 'error') {
        return 'There was a problem...';
      }
      return '';
    },
    resultMessage: function () {
      return this.resultErrorMsg ? this.resultErrorMsg : this.resultSuccessMsg;
    },
  },

  methods: {
    clicked: function (val) {
      console.log('Save btn clicked - value recd:', val);
    },
    checkBoxChanged: function (val) {
      console.log('checkbox!', val);
    },

    setSubmitted: function () {
      this.formSubmitted = true;
    },
    resetSubmitted: function () {
      this.formSubmitted = false;
    },
    setField: function (fieldValue, fieldName) {
      this.form[fieldName].value = fieldValue;
      //   if (
      //     (fieldName === 'country' && fieldValue === 'US') ||
      //     fieldValue === ''
      //   ) {
      //     this.form.province.value = '';
      //     this.setComponentKey(); // Trigger rerender of province field component so that value of '' shows in the input element
      //   }
      this.fieldOnInput(fieldName);
    },

    fieldMaxLength: function (fieldName, formSection = 'form') {
      return (
        this.sections[formSection].model.getPropTruncateLength(fieldName) || 50
      );
    },

    // For given field fieldName, on input to the field, i.e. when the value changes, reset the
    // form state to its primitive/original state in terms of form error alerts, form field error alerts, etc.
    fieldOnInput: function (fieldName, formSection = 'form') {
      this.sections[formSection].saveButton.resets++;
      this.sections[formSection].saveButton.doneSaving = false;
      this.sections[formSection].alertNotice.show = false;

      this.resetSubmitted(); // Reset 'form submitted' flag to false, i.e. "starting over" as tho form was never submitted.
    },

    // Special case of 'setField' for the breedId field
    // Event value passed from SelectBreed child component is an object: { breedId: breedId, breed: name-of-breed}
    setBreed: function (breedData) {
      this.form.breedId.value = breedData.breedId;
      if (breedData.breedId !== 'mixed') {
        this.form.breedDesc.value = '';
      }
      this.fieldOnInput('breedId');
    },

    setComponentKey: function () {
      this.componentKey = Date.now();
    },

    updateLayoutState: function () {
      this.$store.dispatch(
        'layout/setShowWelcomeBar',
        this.layout.showWelcomeBar.value
      );
      this.$store.dispatch(
        'layout/setNaveBarSticky',
        this.layout.navBarSticky.value
      );
    },

    // Disable/enable all form fields and form buttons
    // btnSection: The name of the form section containing the button that was clicked
    // disable: boolean. Default: true. If true, disable all fields; if false,
    // enable all fields
    disableForm: function (btnSection, disable = true) {
      Object.keys(this.sections).forEach((section) => {
        // Disable each button, except the one that was clicked
        if (section !== btnSection) {
          this.sections[section].saveButton.disabled = disable;
        }
        // Disabled each field in each section
        Object.keys(this[section]).forEach((fieldName) => {
          this[section][fieldName].disabled = disable;
        });
      });
    },

    doEdit: async function (formSection) {
      // this.$store.dispatch('layout/setNaveBarSticky', !this.navBarSticky);
      // this.$store.dispatch('layout/setShowWelcomeBar', !this.showWelcomeBar);
      this.sections[formSection].alertNotice.show = false;

      var formData = {};
      Object.keys(this[formSection]).forEach((fieldName) => {
        formData[fieldName] = this[formSection][fieldName].value;
      });

      var Model = this.sections[formSection].model;
      var dataModel = Model.update(formData); // Validation here - may or may not be validation rules in schema... that's ok!
      var modelSnapshot = Model.getSnapshot(dataModel);
      console.log(modelSnapshot);
      var userDocRef = this.$fapi.getDocRefById('users', this.authUser.uid);

      try {
        this.disableForm(formSection);
        await userDocRef.update(modelSnapshot);
        this.$store.dispatch('setUserProfile', modelSnapshot);
        this.sections[formSection].saveButton.doneSaving = true;
        // Run post-update function, if any
        if (typeof this.sections[formSection].postUpdate === 'function') {
          this.sections[formSection].postUpdate();
        }
        // console.log(r);
      } catch (err) {
        this.sections[formSection].alertNotice.show = true;
        this.sections[formSection].alertNotice.message = err.message;
        this.sections[formSection].saveButton.resets++;
        // console.error(err.message);
      }
      // Enable the disabled form
      this.disableForm(formSection, false);
    },
  },

  created: async function () {
    // userProfile: Loaded from state via computed property (via mapGetter)
    if (!this.userProfile) {
      var userDoc = await this.$fapi.getDocById('users', this.authUser.uid);
      if (userDoc.exists) {
        // console.log(userDoc.data());
        this.$store.dispatch('setUserProfile', userDoc.data());
      } else {
        // If doc doesn't exist (it SHOULD, but if for some reason wasn't created during user registration, create it)
        await this.db.collection('users').doc(this.authUser.uid).set({
          enabled: true,
          agreeTermsPrivacy: true,
          agreeCookies: true,
        });
      }
    }

    Object.keys(this.sections).forEach((section) => {
      Object.keys(this[section]).forEach((fieldName) => {
        if (this.userProfile[fieldName] !== undefined) {
          this[section][fieldName].value = this.userProfile[fieldName];
        }
      });
    });
  },
};
</script>

<style>
/* .hr-test {
  margin: 3rem;
  border: 1px solid red;
} */
</style>